<template>
  <div>
    <h3 class="mb-3">Month payer groups</h3>
    
    <table v-if="previews !== null && previews.length > 0" class="table text-nowrap preview-table">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Month</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tr
          v-for="preview in previews"
          :key="preview.yearMonth"
        >
          <td>
            <month-payer-group-link :groupYearMonth="preview.yearMonth" />
          </td>
          <td>
            {{preview.inited | getMonthPayerBillingGroupPreviewsStatusStr}}
          </td>
        </tr>
    </table>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import { getMonthPayerBillingGroupPreviewsStatusStr } from '../model/billing_stat.js';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

import MonthPayerGroupLink from './MonthPayerGroupLink.vue';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
  name: 'MonthPayerGroups',

  components: {
    MonthPayerGroupLink,
    LoadingIndicator,
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,
      previews: null,
    };
  },

  computed: {  
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },
  },

  created() {
    this.loadPreviews();
  },

  methods: {
    loadPreviews() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = '/stat/month_payer_group_previews';
      HTTP.get(url)
      .then(response => {
        this.previews = response.data.data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    }
  },

  filters: {
    getMonthPayerBillingGroupPreviewsStatusStr,
  }
};
</script>

<style scoped>
  .preview-table {
    max-width: 400px;
  }
</style>
